module.exports = __webpack_public_path__ + "img/icon-3.cf262cb6.svg";